
import '@/assets/scss/index.scss'

export default {
  components: {
  },
  data () {
    return {
      dialogFormVisible: false
    }
  },
  watch: {
    dialogFormVisible (data) {
      console.log('data ==={}', data)
      if (!data) {
        this.dialogFormVisible = false
      }
      // if (this.dialogFormVisible) {
      //   this.openPpup()
      // }
    }
  },
  mounted () {
  },
  methods: {
    closePpup () { // 팝업 닫기
      this.$emit('close')
    }
  }
}
